<!--
 * @Description: 
 * @Author: luckymiaow
 * @Date: 2022-04-29 15:13:52
 * @LastEditors: luckymiaow
-->

<script lang="ts" setup>
import type { TreeSelectProps } from 'ant-design-vue';
import { TreeSelect as ATreeSelect } from 'ant-design-vue';
import { computed, useAttrs, useSlots } from 'vue';
import { get } from 'lodash-es';
import useForm, { readOnlySlot } from '../../form/src/useFormConfig';
import useSlot from '../../hooks/useSlot';
import type { FormConfig } from '../../form/types';

const { getBindValue } = useForm<FormConfig & TreeSelectProps>({ componentName: 'tree-select', attrs: useAttrs() });

const { useExcludeSlots } = useSlot({ slots: useSlots() }, []);

function findNode(tree: any, value: any): any {
  if (tree == null) {
    return null;
  }
  if (get(tree, getBindValue.value.fieldNames?.value || 'value') === value) {
    return tree;
  }

  const children = get(tree, getBindValue.value.fieldNames?.children || 'children');
  if (children != null && children.length > 0) {
    for (const child of children) {
      const node = findNode(child, value);
      if (node != null) {
        return node;
      }
    }
  }
  return null;
}

function findNodes(trees: any, values: any) {
  const nodes = [];
  for (const value of values) {
    for (const tree of trees) {
      const node = findNode(tree, value);
      if (node != null) {
        nodes.push(node);
      }
    }
  }
  return nodes;
}

const showData = computed(() => {
  const { treeData, value } = getBindValue.value;
  const _value = typeof value === 'string' ? [value] : value;
  let _options = findNodes(treeData, _value);
  return _options;
});

function showValue() {
  return showData.value?.map((e: any) => get(e, getBindValue.value.fieldNames?.label || 'label')).join('、');
}
</script>

<script lang="ts">
export default {
  name: 'TreeSelect',
};
</script>

<template>
  <span
    v-if="getBindValue?.readOnly"
    :class="getBindValue?.readOnlyClassName"
    :style="getBindValue?.readOnlyStyle ? getBindValue?.readOnlyStyle : {}"
    ><slot v-if="readOnlySlot in $slots" :name="readOnlySlot" :text="getBindValue.value" :data="showData">{{
      showValue()
    }}</slot
    ><template v-else>{{ showValue() }}</template></span
  >
  <a-tree-select v-else v-bind="getBindValue">
    <template v-for="(slot, key) in useExcludeSlots" :key="key" #[key]="scope">
      <slot :name="key" v-bind="scope ?? {}"> </slot>
    </template>
  </a-tree-select>
</template>
